import React from 'react';
import './SectionHeading.css';

const SectionHeading = ({ text, IconComponent, color = '#f1c40f' }) => {
  return (
    <div className="section-heading-wrapper">
      <h3 className="section-heading" style={{ color }}>
        {IconComponent && (
          <IconComponent className="heading-icon" style={{ color }} />
        )}
        {text}
      </h3>
      <div className="section-underline" style={{ backgroundColor: color }}></div>
    </div>
  );
};

export default SectionHeading;
